// src/api/userAPI.js
import axiosInstance from '../utils/axios';

const historyAPI = {
    // CREATE
    createhistory: (data) => axiosInstance.post('/histories/create', data),

    // READ
    gethistorys: (params) => axiosInstance.get('/histories/list', { params: params }),
    gethistoryByIdUser: (params) => axiosInstance.get(`/histories/list/`, { params: params }),
    getdepositById: (id) => axiosInstance.get(`/histories/view/${id}`),

    // UPDATE
    updatehistory: (id, data) => axiosInstance.put(`/histories/update/${id}`, data),

    // DELETE
    deletehistory: (id) => axiosInstance.delete(`/histories/delete/${id}`),
};

export default historyAPI;
